/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Documents_PlaceholderInputs */

const en_case_detail_documents_placeholder = /** @type {(inputs: Case_Detail_Documents_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document management will be available soon.`)
};

const pt_br2_case_detail_documents_placeholder = /** @type {(inputs: Case_Detail_Documents_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O gerenciamento de documentos estará disponível em breve.`)
};

/**
* | output |
* | --- |
* | "Document management will be available soon." |
*
* @param {Case_Detail_Documents_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_documents_placeholder = /** @type {((inputs?: Case_Detail_Documents_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Documents_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_documents_placeholder(inputs)
	return pt_br2_case_detail_documents_placeholder(inputs)
});